import axios from '../axios';

const endpoints = {
  getProfile: () => axios.get('/user/info'),
  getParseBytUser: (user_id) => axios.get(`/parse/user/${user_id}`),
};

export default endpoints;